export const extendConnector = (connector, id, name) => {
    const extendedConnector = connector;
    extendedConnector.id = id;
    extendedConnector.displayName = name;
    return extendedConnector;
};
//# sourceMappingURL=utils.js.map